import { Typography } from '@tractian/ui'
import { useTranslation } from 'react-i18next'

/**
 * The Private Network Access caveat: pointing the deployed app at localhost
 * needs a one-time browser grant, or an HTTPS tunnel instead.
 */
export function MatrixPnaNote() {
  const { t } = useTranslation('matrix')

  return (
    <section
      data-testid="matrix-pna-info"
      className="flex flex-col gap-1 rounded-md border border-blue-200 bg-blue-50 p-4"
    >
      <Typography.Text size="small" variant="highlight">
        {t('pna.title')}
      </Typography.Text>
      <Typography.Text size="small" color="body">
        {t('pna.description')}
      </Typography.Text>
    </section>
  )
}
